import { AsyncPipe } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { PlanIntervalType } from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'billing-cycle',
  templateUrl: './billing-cycle.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class BillingCycleComponent {
  private cd = inject(ChangeDetectorRef);

  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);

  setCycleType(intervalType: any) {
    if (intervalType)
      return PlanIntervalType[intervalType as keyof typeof PlanIntervalType];
    else return null;
  }
}
